import React, { useEffect, useMemo } from 'react';
import VideoTranscript from '../../components/VideoTranscript/index';
import { WTitle } from '../../components/Widget';
import Person from '../../../../../../assets/education/ot/person.png';
import Light from '../../../../../../assets/education/ptm/light.png';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const ID = '1';
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#videoOt');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#videoOt')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#videoOt')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#videoOt')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document?.querySelector('#videoOt')?.removeEventListener('play', onPlay);
  }, []);
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  useEffect(() => {
    if (isVisible) {
      updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [isVisible]);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <WTitle title={paragraphsSettings?.header} />
          <img className="person" src={Person} alt="" />
          <div className="course-box">
            <div className="video-container">
              <video
                id="videoOt"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
            <img className="light" src={Light} alt="" />
          </div>
        </div>
      </div>
      <div className="welcome-bubble">
        <div className="welcome-bubble-content" ref={targetRef}>
          {isVisible && (
            <span className="text-focus-in">
              {paragraphsSettings?.description}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section0;
